import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import LoggedUserContext from '../../../../contextProviders/LoggedUserContext';
import { displayUserName } from '../../../../services/utilityFunctions';
import JourneyProp from '../../propTypes/journeyProp';
import AmGaugeChart from '../../../../commonComponents/charts/AmGaugeChart';
import JourneyProgress from '../JourneyProgress';
import JourneyStepProp from '../../propTypes/journeyStepProp';
import WalletCoinsIcon from '../../../shared/icons/WalletCoinsIcon';
import CharityCoinsIcon from '../../../shared/icons/CharityCoinsIcon';
import JourneyStatsTrophy from './JourneyStatsTrophy';
import JourneyStatsCoins from './JourneyStatsCoins';
import JourneyStatsCoupon from './JourneyStatsCoupon';

export default function JourneyStats({ journey, step }) {
  const { loggedUser } = useContext(LoggedUserContext);
  const userImage = loggedUser.image
    ? loggedUser.image.thumb
    : '/images/no_image_upload.png';

  const rewards = step.rewards || {};

  const trophies = Object.entries(rewards.trophies || {})
    .filter(([trophy, value]) => !!value)
    .map(([trophy]) => trophy);

  const coins = rewards.coins || {};
  const coupons = rewards.coupons || [];

  const skills = journey.skillLevels || [];

  return (
    <>
      <div className="row">
        <div className="col-lg-12 col-md-12 journey-overall-stats">
          <div className="row">
            <div className="col-lg-3 col-lg-3 col-sm-3 col-3 m--padding-right-5">
              <div className="journey-overall-stats-user">
                <img src={userImage} alt="course" />
              </div>
            </div>
            <div className="col-lg-9 col-lg-9 col-sm-9 col-9 m--padding-left-5">
              <h3>{displayUserName(loggedUser)}</h3>
              <p>{loggedUser.position || loggedUser.title}</p>
            </div>
          </div>
          <hr />

          <div className="row">
            <div className="col-lg-12">
              <JourneyProgress progress={journey.progress || 0} />
            </div>
          </div>
          <hr />

          {skills.length > 0 && (
            <>
              <div className="row">
                <div className="col-lg-12">
                  <AmGaugeChart
                    options={{
                      category: 'name',
                      value: 'level',
                      axisLimits: { min: 0, max: 6 },
                    }}
                    chartId="skillsChart"
                    stats={skills}
                    containerClass="journey-skills-chart"
                  />
                </div>
              </div>
              <hr />
            </>
          )}

          <div className="row">
            <div className="col-lg-12">
              <div className="row">
                {trophies.map(trophy => (
                  <JourneyStatsTrophy key={trophy} trophy={trophy} />
                ))}
              </div>
              <div className="row">
                {!!coins.wallet && (
                  <JourneyStatsCoins
                    value={coins.wallet}
                    titleClass="text-dynamic"
                    icon={<WalletCoinsIcon color="dynamic" />}
                  />
                )}
                {!!coins.charity && (
                  <JourneyStatsCoins
                    value={coins.charity}
                    titleClass="text-info"
                    icon={<CharityCoinsIcon color="info" />}
                  />
                )}
                {coupons.map(coupon => (
                  <JourneyStatsCoupon
                    key={coupon.name + coupon.expirationDate}
                    coupon={coupon}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

JourneyStats.propTypes = {
  journey: PropTypes.shape(JourneyProp.propType).isRequired,
  step: PropTypes.shape(JourneyStepProp.propType).isRequired,
};

JourneyStats.defaultProps = {
};
